export interface IUserMembership {
  id?: number;
  resourceId?: number;
  fiscalSetupId?: number;
  fiscalSetupName?: string;
  securityGroups?: string[];
  userId?: number;
  installedAppNames?: string[];
}
